
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-hooks-use-keyboard-demo-xflow-hooks-use-key-board"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.zh.md?type=demo')
};